module.exports = __webpack_public_path__ + "static/landing-pages-mobile-f6fbfccf1c8c41bfcc990c111a9d75bb.jpg";